var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-input",class:{
    'vp-mb-61': _vm.lastFieldInSection && _vm.isInvalid,
    'vp-mb-37': _vm.isInvalid,
    'vp-mb-16': !_vm.isInvalid,
  }},[_c('VpInput',{attrs:{"label":_vm.field.is_mandatory && !_vm.field.is_optional
        ? _vm.field.name
        : _vm.field.name + ` ${_vm.$t('common.optionalWithBrackets')}`,"width":"416","maxlength":"20","invalid":_vm.isInvalid,"errMsg":_vm.isInvalid ? _vm.errMsg : ''},on:{"input":_vm.emitUpdate},model:{value:(_vm.inputModel.value),callback:function ($$v) {_vm.$set(_vm.inputModel, "value", $$v)},expression:"inputModel.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }